import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { Link } from "react-router-dom";
import "./BlogManager.css";

function BlogManager() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const fetchBlogs = async () => {
      const snapshot = await getDocs(collection(db, "blogs"));
      const blogList = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setBlogs(blogList);
      setLoading(false);
    };
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Delete this blog?")) {
      await deleteDoc(doc(db, "blogs", id));
      setBlogs((prev) => prev.filter((b) => b.id !== id));
    }
  };

  if (loading) return <p>Loading blogs...</p>;

  const filtered = blogs.filter((b) =>
    b.title.toLowerCase().includes(query.toLowerCase()) ||
    (b.author || "").toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="blog-manager-container">
      <div className="manager-header">
        <h2>Manage Blogs</h2>
        <div className="manager-actions">
          <input
            type="search"
            placeholder="Search by title or author"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Link to="/upload-blog" className="btn primary">Add New</Link>
        </div>
      </div>

      <div className="table-wrap">
        <table className="blog-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Author</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((b) => (
              <tr key={b.id}>
                <td className="title-cell">{b.title}</td>
                <td>{b.author}</td>
                <td>{b.postDate && b.postDate.seconds ? new Date(b.postDate.seconds * 1000).toLocaleDateString() : new Date(b.postDate).toLocaleDateString()}</td>
                <td className="actions">
                  <Link className="icon-btn edit" to={`/edit-blog/${b.id}`} aria-label={`Edit ${b.title}`}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="currentColor" />
                      <path d="M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor" />
                    </svg>
                  </Link>
                  <button className="icon-btn delete" onClick={() => handleDelete(b.id)} aria-label={`Delete ${b.title}`}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 6h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default BlogManager;